module.exports = __webpack_public_path__ + "media/common/images/badges/gray/sekac-a89b4a13ff4af498fdacd922442945b1.svg";